// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","453":"64aababc","732":"a38800b4","977":"00b284dc"}[chunkId] + ".chunk.js";
};